// extracted by mini-css-extract-plugin
export default {"tasklist":"TaskList_tasklist__9rRgp","container_btn":"TaskList_container_btn__nCXKL"};